import React from 'react';
import {render} from 'react-dom';

import {ArticleShareWidget} from '../../website-ui/components/article-share-widget';
import {isFromGoogleNews} from '../../website-ui/helpers/google-news';

const initArticleShareWidget = ($wrapper, articleId, isMobile) => {

  const shouldRenderShareWidget = $wrapper && articleId && (!isMobile || !isFromGoogleNews || Boolean(navigator.share));

  if (shouldRenderShareWidget) {
    render(
      <ArticleShareWidget articleId={articleId} />,
      $wrapper
    );
  }
};

export {initArticleShareWidget};
